import { useGetTariffsQuery } from 'Services/ProductManagement/Features/Tariff/tariffApi'
import type { FetchTariffListParams } from 'Services/ProductManagement/Features/Tariff/types'
import { ROWS_PER_PAGE_DEFAULT, SORT_ORDER_ASC } from 'Util/constants'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

function useTariffsWithParams() {
  const [searchParams, setSearchParams] = useSearchParams()

  const [searchQueryParams, setSearchQueryParams] = useState<FetchTariffListParams>({
    filter: searchParams.get('filter') ?? undefined,
    search_text: searchParams.get('search_text') ?? undefined,
    sort_by: searchParams.get('sort_by') ?? 'tariffCode',
    sort_order: searchParams.get('sort_order') ?? SORT_ORDER_ASC,
    start_index: searchParams.get('start_index') ?? undefined,
    count: ROWS_PER_PAGE_DEFAULT
  })

  const {
    data: { resources: tariffs } = { resources: [] },
    data: { total_results: totalResults } = { total_results: 0 },
    isFetching
  } = useGetTariffsQuery(searchQueryParams)

  const setQueryParams = () => {
    Object.entries(searchQueryParams).forEach(([key, value]) => {
      if (value) {
        searchParams.set(key, value.toString())
      } else {
        searchParams.delete(key)
      }
    })

    setSearchParams(searchParams)
  }

  useEffect(() => {
    setQueryParams()
  }, [searchQueryParams])

  return {
    tariffs,
    isFetching,
    searchQueryParams,
    setSearchQueryParams,
    totalResults
  }
}

export default useTariffsWithParams
